export const TASK_TYPE_TEXT_MAP = {
  learn: '学习任务',
  operate: '运营任务',
  remind: '提醒任务',
};

// 团队/学习不变
export const option: any = {
  color: ['#27AE60', '#FF6D5E', '#578FFF', '#F2C94C', '#E6E8ED', '#BBE4FF'],
  tooltip: {
    trigger: 'item',
  },
  legend: {
    top: '5%',
    left: 'center',
    show: false,
  },
  graphic: {
    type: 'text',
    left: 'center',
    top: 'center',
    style: {
      // text: "七日内失效",
      fontSize: '14',
      textAlign: 'center',
      fontWeight: 'bold',
      fill: '#000',
      width: 30,
      height: 30,
    },
  },
  series: [
    {
      type: 'pie',
      radius: ['43%', ' 53%'],
      label: {
        formatter: '{name|{b}} {value|{c}}',
        minMargin: 5,
        rich: {
          value: {
            marginLeft: 5,
            fontSize: 20,
            color: '#000',
            fontWeight: 400,
          },
        },
      },
      itemStyle: {
        borderWidth: 2,
        borderColor: '#fff',
      },
      emphasis: {
        label: {
          show: true,
          fontSize: '20',
          fontWeight: 'bold',
        },
      },
      data: [],
    },
  ],
};
// echarts表数据为空时的配置
export const nullDataOption = {
  color: ['#E6E8ED'],
  tooltip: {
    show: true, // 显示提示框
  },
  graphic: {
    type: 'text',
    left: 'center',
    top: 'center',
    style: {
      text: '今日任务暂无数据',
      textAlign: 'center',
      fill: '#000',
      width: 30,
      height: 30,
    },
  },
  series: [
    {
      silent: true,
      type: 'pie',
      itemStyle: {
        borderWidth: 0,
      },
      radius: ['43%', '53%'],
      label: {
        formatter: '',
      },
      data: [{ value: 100 }],
    },
  ],
};
// 学习任务不变
export const handleData = (data: any, name: string) => {
  let text = null;
  if (name == 'totalSummary') {
    text = `总任务\n${data?.[name]?.totalCount}`;
    return {
      series: [
        {
          type: 'pie',
          silent: false,
          data: [
            { value: data?.[name]?.finishedCount ? data?.[name]?.finishedCount : '', name: '已完成', label: { color: '#626366' } },
            { value: data?.[name]?.unfinishedCount ? data?.[name]?.unfinishedCount : '', name: '未处理', label: { color: '#626366' } },
            { value: data?.[name]?.markFinishedCount ? data?.[name]?.markFinishedCount : '', name: '标记完成', label: { color: '#626366' } },
            { value: data?.[name]?.ignoredCount ? data?.[name]?.ignoredCount : '', name: '已忽略', label: { color: '#626366' } },
            { value: data?.[name]?.expiredCount ? data?.[name]?.expiredCount : '', name: '已过期', label: { color: '#626366' } },
            { value: data?.[name]?.notStartedCount ? data?.[name]?.notStartedCount : '', name: '未开始', label: { color: '#626366' } },
          ],
        },
      ],
      graphic: {
        style: {
          text,
        },
      },
    };
  } if (name == 'todaySummary') {
    text = `今日任务\n${data?.[name]?.totalCount}`;
    return {
      color: ['#27AE60', '#FF6D5E', '#578FFF', '#F2C94C', '#E6E8ED', '#BBE4FF'],
      series: [
        {
          type: 'pie',
          silent: false,
          data: [
            { value: data?.[name]?.finishedCount ? data?.[name]?.finishedCount : '', name: '已完成', label: { color: '#626366' } },
            { value: data?.[name]?.unfinishedCount ? data?.[name]?.unfinishedCount : '', name: '未处理', label: { color: '#626366' } },
            { value: data?.[name]?.markFinishedCount ? data?.[name]?.markFinishedCount : '', name: '标记完成', label: { color: '#626366' } },
            { value: data?.[name]?.ignoredCount ? data?.[name]?.ignoredCount : '', name: '已忽略', label: { color: '#626366' } },
            { value: data?.[name]?.expiredCount ? data?.[name]?.expiredCount : '', name: '已过期', label: { color: '#626366' } },
            { value: data?.[name]?.notStartedCount ? data?.[name]?.notStartedCount : '', name: '未开始', label: { color: '#626366' } },
          ],
        },
      ],
      graphic: {
        style: {
          text,
        },
      },
    };
  }
  text = `七日内将过期\n${data?.[name]?.totalCount}`;

  return {
    series: [
      {
        type: 'pie',
        silent: false,
        data: [
          { value: data?.[name]?.finishedCount ? data?.[name]?.finishedCount : '', name: '已完成', label: { color: '#626366' } },
          { value: data?.[name]?.unfinishedCount ? data?.[name]?.unfinishedCount : '', name: '未处理', label: { color: '#626366' } },
          { value: data?.[name]?.markFinishedCount ? data?.[name]?.markFinishedCount : '', name: '标记完成', label: { color: '#626366' } },
          { value: data?.[name]?.ignoredCount ? data?.[name]?.ignoredCount : '', name: '已忽略', label: { color: '#626366' } },
          { value: data?.[name]?.expiredCount ? data?.[name]?.expiredCount : '', name: '已过期', label: { color: '#626366' } },
          { value: data?.[name]?.notStartedCount ? data?.[name]?.notStartedCount : '', name: '未开始', label: { color: '#626366' } },
        ],
      },
    ],
    graphic: {
      style: {
        text,
      },
    },
  };
};

// 学习任务不变
export const TeamStatus = [
  { label: '已完成', color: '#27AE60' },
  { label: '未处理', color: '#FF6D5E' },
  { label: '标记完成', color: '#578FFF' },
  { label: '已忽略', color: '#F2C94C' },
  { label: '已过期', color: '#E6E8ED' },
  { label: '未开始', color: '#BBE4FF' },
];
export const BUTTONTEXT = {
  ignore: {
    text: '忽略',
    status: 3,
  },
  mark_finished: {
    text: '标记完成',
    status: 2,
  },
  toDeal: {
    text: '去处理',
  },
};

export default {
  option,
  TeamStatus,
  nullDataOption,
  handleData,
  BUTTONTEXT,
};
